module.exports = __webpack_public_path__ + "static/img/img6.c9ce0e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img6.jpg
// module id = DB1k
// module chunks = 0